export default __webpack_public_path__ + "static/media/placeholder-7.6de5fd55.png";